import styles from "./styles/create-button.module.scss";
import CursorWrapper from "@/components/common/cursor-wrapper";
import Loader from "@/components/common/loader";
import Image from "next/image";
import magicStickIcon from "@/assets/convert/magic-stick.svg";
import React from "react";

interface CreateButtonProps {
  isActive: boolean;
  isLoading: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}
const CreateButton = ({
  isActive,
  isLoading,
  onClick,
  children,
}: CreateButtonProps) => {
  return (
    <div className={styles.container}>
      <CursorWrapper isActive={isActive}>
        <div
          className={isActive ? styles.wrapper : styles.inactive_button}
          role="button"
          data-tooltip-id="voiceTooltip"
          data-tooltip-content="Please select a voice to start song generation"
          onClick={isLoading ? undefined : onClick}
        >
          {children}
          <div className={styles.button_content}>
            {isLoading ? (
              <Loader size={"48px"} />
            ) : (
              <>
                <Image
                  className={styles.icon}
                  src={magicStickIcon}
                  alt="create"
                />
                <div className={styles.generate_text}>Create</div>
              </>
            )}
          </div>
        </div>
      </CursorWrapper>
    </div>
  );
};

export default CreateButton;
